import { AppErrorContract, ContextContract } from "./types";

export const appErrorDefault: AppErrorContract = {
    type: undefined
}

export const contextDefault: ContextContract = {
    appErrorState: appErrorDefault,
    setAppErrorState: () => {}
}
